export default __webpack_public_path__ + "static/char-v-58-0e36e997a68a804bfb8f8feef257492e.webp";